import { DataTableColumnType } from '../_custom/DataTable/DataTable.types';
import { DEAL_COLUMN_KEYS } from '../../store/investor/constants';

export const VIEW_ALL_PROPERTIES_ACTION_KEY = 'VIEW_ALL_PROPERTIES';
export const VIEW_ALL_PROPERTIES_LABEL = 'View All Properties';
export const DRAWER_HEADING = 'All Properties';
export const DEFAULT_NOT_FOUND_MESSAGE = 'Record not found';
export const SEARCH_PLACEHOLDER = 'Search Property';
export const NO_MATCHING_PROPERTIES_MESSAGE = 'No matching properties';
export const CLEAR_SEARCH_LABEL = 'Clear search';
export const CLEAR_ICON_SIZE = '0.625rem';
export const DRAWER_WIDTH = '39rem';

// URL flag AskAicaV2 reads to hide its floating icon while the drawer is open.
export const VIEW_ALL_PROPERTIES_DRAWER_PARAM = 'viewAllProperties';
// Separate flag for the Deals table: it shares the company page with the header, and two hosts on one
// flag would keep clearing each other's value.
export const VIEW_ALL_DEAL_PROPERTIES_DRAWER_PARAM = 'viewAllDealProperties';

// Column types excluded from the drawer (pure UI, no value).
export const EXCLUDED_COLUMN_TYPES: DataTableColumnType[] = [DataTableColumnType.ACTION, DataTableColumnType.EXPANDABLE];

// COMPONENT fields excluded from the drawer (the row kebab).
export const EXCLUDED_COMPONENT_FIELDS: string[] = [DEAL_COLUMN_KEYS.ACTIONS];

// MODAL_ACTION fields that carry a value, rendered read-only.
export const DATA_PENDING_COLUMN_FIELD = 'borrowerRequirementsCount';
export const VALUE_BEARING_MODAL_FIELDS = new Set<string>([DATA_PENDING_COLUMN_FIELD, 'lenderDataPending']);
